// extracted by mini-css-extract-plugin
export default {"import-schema-btn":"styles_import-schema-btn__E38Rx"};